import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "comment__file" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VideoAttachmentItem = _resolveComponent("VideoAttachmentItem")!
  const _component_ImageItem = _resolveComponent("ImageItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          loading: _ctx.loading
        }, null, 8, ["loading"]))
      : (_ctx.isVideo)
        ? (_openBlock(), _createBlock(_component_VideoAttachmentItem, {
            key: _ctx.currentVideoUrl,
            file: _ctx.item,
            videoPath: _ctx.currentVideoUrl,
            hideInfo: true,
            hidePoster: true,
            fancyboxData: "fancybox_comment",
            useSharedFancybox: true,
            class: "comment__file-video",
            onClick: _ctx.updateVideoLink
          }, null, 8, ["file", "videoPath", "onClick"]))
        : (_ctx.isImage)
          ? (_openBlock(), _createBlock(_component_ImageItem, {
              key: 2,
              attachment: _ctx.item,
              blobUrl: _ctx.blobUrl,
              fancyboxData: "fancybox_comment",
              fileMetadataId: _ctx.item.id,
              loadFullSize: true,
              class: "comment__file-image"
            }, null, 8, ["attachment", "blobUrl", "fileMetadataId"]))
          : _createCommentVNode("", true)
  ]))
}